import { GetPlaybookResults } from "@/graphql/queries/GetPlaybookResults";
import { useGraphQuery } from "@dashboard/library";

export const useGetPlaybookResults = (callId?: string | null) => {
  const result = useGraphQuery(GetPlaybookResults, {
    variables: { input: { callId: callId ?? "" } },
    skip: !callId,
  });

  return {
    ...result,
    playbookResult: result.output?.getPlaybookResults?.items[0],
  };
};
